<template>
  <div class="item-wrap">
    <div class="item" v-for="(item, index) in productList" :key="index">
      <div class="mask-layer">
        <i class="iconfont iconchakan"></i>
        <span @click="selectProduct(item)">
          选择模板
        </span>
      </div>
      <div class="product-img">
        <img :src="item.image" alt="" />
      </div>
      <div class="product-attached">
        <span
          v-for="(desImg, desImgIndex) in item.attachments"
          :key="desImgIndex"
        >
          <img
            :src="desImg"
            alt=""
            width="28px"
            height="28px"
            v-if="desImgIndex < 6"
          />
        </span>
      </div>
      <div class="product-price">
        <span>${{ item.price }}</span>
      </div>
      <div class="product-title">
        {{ item.title }}
      </div>
      <div class="product-comments">
        <span>{{ parseInt(Math.random() * (10000 - 8000) + 8000) }}+ </span>
        comments
      </div>
      <div class="product-shop">
        <span>
          {{ item.brand }}
        </span>
        <i class="iconfont iconownbrand"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { templateData } from "./../data";
const _templateData = JSON.parse(JSON.stringify(templateData));
export default {
  data() {
    return {
      productList: _templateData,
    };
  },
  methods: {
    selectProduct(item) {
      this.$store.commit("setData", {
        dataKey: "template",
        value: {
          default: {},
          edit: {},
        },
      });
      item.template = { id: item.id };
      item.id = null;
      this.$store.commit("setData", {
        setKey: "template.default",
        value: item,
      });
      this.$store.commit("setData", {
        setKey: "template.edit",
        value: item,
      });
      this.$emit("changeStep", 1);
    },
  },
};
</script>
<style scoped lang="scss">
.item-wrap {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 236px;
    height: 432px;
    box-sizing: border-box;
    padding: 8px;
    /*background: #f5f5f5;*/
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 0 2px 2px 0;

    &:hover {
      > div.mask-layer {
        background: rgba(0, 0, 0, 0.3);
        z-index: 1;
        opacity: 1;
        transition: all 0.3s linear;
      }
    }

    div.mask-layer {
      border-radius: 10px;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transition: all 0.3s linear;
      opacity: 0;

      > i {
        font-size: 70px;
        color: #ffffff;
        margin-bottom: 20px;
      }

      > span {
        letter-spacing: 1px;
        background: #fdad53;
        padding: 12px 26px;
        border-radius: 10px;
        color: #ffffff;
        cursor: pointer;
        margin-bottom: 80px;
      }

      &.active {
        z-index: 1;
        opacity: 1;
        background: rgba(0, 0, 0, 0.8);
      }
    }

    > .product-img {
      width: 220px;
      height: 220px;
      overflow: hidden;

      > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    > .product-attached {
      margin: 12px 0;
      display: flex;
      align-items: center;

      > span {
        margin-right: 8px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    > .product-price {
      font-size: 22px;
      margin: 0 0 10px 0;
      color: #e50011;
    }

    > .product-title {
      font-size: 13px;
      color: #595757;
      text-overflow: ellipsis;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-bottom: 8px;
    }

    > .product-comments {
      font-size: 13px;
      line-height: 20px;
      color: #adadad;
      margin-bottom: 8px;

      > span {
        font-weight: bolder;
        color: #089bab;
      }
    }

    > .product-shop {
      display: flex;
      align-items: center;

      span {
        font-size: 13px;
        line-height: 20px;
        color: #adadad;
        max-width: 80%;
        overflow: hidden;
        height: 20px;
      }

      i {
        margin-left: 8px;
        font-size: 22px;
        color: #089bab;
      }
    }
  }
}
</style>
